import '../../main.css';

import React from 'react';
import Tooltip from 'react-tooltip-lite';

import { theme } from '../../theme';

interface ITooltip {
	children: JSX.Element | string;
	content: JSX.Element;
	zIndex: number;
	display: 'inline-block' | 'block' | 'inline' | 'flex';
	direction: string;
	distance: number;
	isOpen?: boolean;
	showOnClick?: boolean;
	canBeHovered?: boolean;
}

export const TooltipAtom = ({
	children,
	content,
	isOpen,
	showOnClick,
	zIndex,
	display,
	direction,
	distance,
	canBeHovered,
}: ITooltip) => (
	<Tooltip
		hoverDelay={50}
		tipContentHover={canBeHovered}
		isOpen={isOpen}
		eventOn={showOnClick ? 'onClick' : 'onHover'}
		eventOff="onClick"
		useHover={showOnClick ? false : true}
		arrow={false}
		direction={direction}
		content={content}
		background={theme.colors.tooltip.background.default}
		padding="8px"
		distance={distance}
		styles={{ display }}
		zIndex={zIndex}
	>
		{children}
	</Tooltip>
);
